import { ReparoApi } from './index';

export type MrpAlertLevel = 'RED' | 'AMBER' | 'GREEN' | 'NONE';

export type MrpContributingProduct = {
    productId: string;
    productSku: string | null;
    productName: string;
    demandDailyUnits: number;
    qtyPerFg: number;
    contributionToDailyDemand: number;
    /**
     * Whose BOM set `qtyPerFg`. Null = the lines that apply to all vendors, which is also the
     * answer for every product made only one way.
     *
     * The plan takes the HIGHEST quantity any of a product's vendors asks for, so this is what
     * turns a figure the brand cannot place into one it can open the document for.
     */
    bomVendorId: string | null;
    bomVendorName: string | null;
    /** True when this product's manufacturers do not agree on this line at all. */
    bomVariesByVendor: boolean;
};

export type MrpAlternativeVendor = {
    vendorId: string;
    vendorName: string | null;
    cost: number | null;
    leadTimeDays: number | null;
    moq: number | null;
};

export type MrpAlternateCoverage = {
    materialId: string;
    materialName: string;
    unit: string;
    availableQty: number;
    coveredFgUnits: number;
    rawEquivalentQty: number;
};

export type MrpPlanRow = {
    materialId: string;
    materialSku: string | null;
    materialName: string;
    materialType: 'RM' | 'PM' | 'STAGE';
    unit: string;
    /** Raw on hand + stage stock in the raw's unit. */
    currentStock: number;
    rawStock?: number;
    stageEquivalentStock?: number;
    alternateCoverage?: MrpAlternateCoverage[];
    dailyMaterialDemand: number;
    currentDoH: number | null;
    vendorId: string | null;
    vendorName: string | null;
    leadTimeDays: number | null;
    moq: number | null;
    dohAtArrival: number | null;
    daysToTopUp: number | null;
    rawQty: number | null;
    recommendedPoQty: number | null;
    alertLevel: MrpAlertLevel;
    contributingProducts: MrpContributingProduct[];
    alternativeVendors: MrpAlternativeVendor[];
};

export type MrpRateBasis = 'BACKWARD' | 'FORWARD';

export type MrpPlanConfig = {
    basis: MrpRateBasis;
    salesLookbackDays: number;
};

export type MrpPlanResponse = {
    rows: MrpPlanRow[];
    config: MrpPlanConfig;
};

export const runMrpPlan = async (payload: {
    daysOfCover?: number;
    wastagePercent?: number;
    basis?: MrpRateBasis;
    drrWindow?: number;
}): Promise<MrpPlanResponse> => {
    return ReparoApi<any>({
        method: 'POST',
        url: '/production-planning/mrp/plan',
        body: JSON.stringify(payload),
    });
};
